<template>
  <div class="container is-fluid full-viewport" >
    <div class="columns">
      <div class="column is-offset-2 is-8">
        <div class="card">
          <div class="card-content">
            <div class="columns is-multiline">
              <div class="column is-12 pb-0 ">
                <span class="has-text-weight-bold " >Usuarios</span>
              </div>
              <div class="column is-10 pb-0 ">
                <b-field
                  class="w100"
                  label="Buscar"
                  label-position="on-border">
                  <b-input
                    v-model="textoBusqueda"
                    @input="searchEvent()"
                    icon="search" >
                  </b-input>
                </b-field>
              </div>
              <div class="column is-2 pb-0 ">
                <b-button class="align-center is-success " @click="irNuevo()" >
                  <img src="@/assets/icons/addrow-5.png" style="max-height:20px !important" >
                  Nuevo
                </b-button>
              </div>
            </div>
            <b-table
              :data="listUsuariosFiltrada"
              paginated
              pagination-simple
              :per-page="10"
              striped
              bordered
              heverable >
              <template slot-scope="props">
                <b-table-column field="nombre" label="Nombre" sortable >
                    {{ props.row.nombre }}
                </b-table-column>

                <b-table-column field="email" label="E-Mail" sortable >
                    {{ props.row.email }}
                </b-table-column>
                <b-table-column label="Estado" field="estado" align="center" sortable >
                  <span>
                    <b-tooltip :label="props.row.estado === 'A' ? 'Activo' : 'Inactivo'">
                      <b-icon
                        pack="fas"
                        :type="props.row.estado === 'A' ? 'is-success' : 'is-danger'"
                        :icon="props.row.estado === 'A' ? 'check-circle' : 'times-circle'" />
                    </b-tooltip>
                  </span>
                </b-table-column>
                <b-table-column label="Acciones" align="center" class=" pb-0  pl-0 pr-0 "  width="110" >
                  <b-tooltip label="Modificar">
                    <b-button class="align-center"  size="is-small" @click="irEditar(props.row)" >
                      <img src="@/assets/icons/edit-5.png" style="max-height:25px !important" >
                    </b-button>
                  </b-tooltip>
                  <b-tooltip label="Eliminar">
                    <b-button class="align-center" size="is-small" @click="eliminar(props.row)" >
                      <img src="@/assets/icons/delrow-4.png" style="max-height:25px !important" >
                    </b-button>
                  </b-tooltip>
                </b-table-column>
              </template>
              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon
                        icon="grin-beam-sweat"
                        size="is-large" >
                      </b-icon>
                    </p>
                    <p>No se Encontraron Usuarios.</p>
                  </div>
                </section>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      listUsuarios: [],
      listUsuariosFiltrada: [],
      textoBusqueda: null
    }
  },
  computed: {
    ...mapState({
      token: state => state.token,
    })
  },
  created () {
    this.buscarUsuarios();
  },
  methods: {
    searchEvent() {
      if (this.textoBusqueda == null) {
        this.listUsuariosFiltrada = [ ...this.listUsuarios ]
      } else {
        this.listUsuariosFiltrada = [];
        this.listUsuariosFiltrada = this.listUsuarios.filter(element => (
          element.nombre.toUpperCase().includes(this.textoBusqueda.toUpperCase())
          || element.email.toUpperCase().includes(this.textoBusqueda.toUpperCase())
          || element.estado.toUpperCase().includes(this.textoBusqueda.toUpperCase())
        ))
      }
    },
    async buscarUsuarios () {
			try {
				const resultado = await this.$api.ejecutar('spr_sel_usuarios', [ this.token ])
				if (resultado != null) {
					this.listUsuarios = [ ...resultado ]
					this.listUsuariosFiltrada = [ ...resultado ]
				}
			} catch (error) {
				if (error.message === "Network Error") {
					this.$alertifyNR.genericAlert(error.name + ': <b>Error de Red</b>', "ERROR")
				} else {
					this.$alertifyNR.genericAlert(error.name + ': ' + error.message, "ERROR")
				}
			}
    },
    confirmarEliminar: (me, item) => new Promise(resolve => {
      me.$alertify.confirmWithTitle(
        "Eliminar Usuario",
        `¿Esta seguro de <b>Eliminar</b> al usuario <b>${item.nombre}</b>, con E-mail <b>${item.email}</b> ?, se cerrarán todas las sesiones activas.`,
        () => {
          resolve(true)
        },
        () => { 
          // me.$alertify.warning("No se ha Agregado el Registro");
          resolve(false)
        }
      )
    }),
    async eliminar (item) {
      let continuar =  await this.confirmarEliminar(this, item)
      if (!continuar) {
        return
      }
			const params = [
        this.token,
        item.id_usuario
      ]
      try {
				const resultado = await this.$api.ejecutar('spr_del_usuario', params)
				if (resultado != null) {
          this.$alertifyNR.genericAlert(resultado[0].message, resultado[0].status)
					if (resultado[0].status === 'SUCCESS') {
            this.buscarUsuarios()
					}
				}
			} catch (error) {
				if (error.message === "Network Error") {
					this.$alertifyNR.genericAlert(error.name + ': <b>Error de Red</b>', "ERROR")
				} else {
					this.$alertifyNR.genericAlert(error.name + ': ' + error.message, "ERROR")
				}
			}
    },
    irNuevo () {
      this.$router.push({
        name: 'Mantenimientos/Usuarios/Gestionar'
      })
    },
    irEditar (item) {
      this.$router.push({
        name: 'Mantenimientos/Usuarios/Gestionar',
        params: {
          esEditar: true,
          objUsuario: item
        }
      })
    }
  }
}
</script>